import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Checkbox,
  Collapse,
  Dropdown,
  Flex,
  Input,
  Tag,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import crossIcon from "../../../assets/Icons/crossIcon.svg";
import favoIcon from "../../../assets/Icons/favoIcon.svg";
import FilterIcon2 from "../../../assets/Icons/FilterVariant2.svg";
import searchIcon from "../../../assets/Icons/input-search-icon.svg";
import recentIcon from "../../../assets/Icons/recentIcon.svg";
import starIcon from "../../../assets/Icons/star.svg";

import { useDispatch, useSelector } from "react-redux";
import { setQuery } from "../../../store/filters";
import "../../actionHeader/ActionHeader.scss";

const { Panel } = Collapse;

const FilterDropdown = ({
  setPrimaryItems,
  setSecondaryItems,
  secondaryItems,
  primaryItems,
  fetchData,
  fetchData2,
  fetchData3,
  variant = "1",
  updateApis = () => { }
}) => {
  const [open, setOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedCategory, setSelectedCategory] = useState("portfolios");
  const [categorySelections, setCategorySelections] = useState({});
  const [readyToApply, setReadyToApply] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  const { filter_list, query } = useSelector((state) => state?.filters);
 
  
  const variant1Categories = [
    { title: "Product", value: "product" },// pending from backend 
    { title: "POS", value: "pos" }, // pending from backend 
    { title: "Languages ", value: "languages" },
    { title: "Region", value: "region" },
    { title: "Bank", value: "portfolios" },
       { title: "Disposition", value: "disposition" },
    { title: "Aging Bucket", value: "buckets" },
    { title: "Branch", value: "branches" },
    { title: "Supervisor", value: "supervisors" },
    { title: "Team Lead", value: "teamleads" },
    { title: "Tele caller", value: "telecallers" },
    { title: "Field Agent", value: "field_agents" },
  ];

  const variant2Categories = [
    { title: "Recently Selected", value: "recently" },
    { title: "Favourites", value: "favourites" },
    { title: "State Wise", value: "states" },
    { title: "Portfolio Wise", value: "portfolios" },
    { title: "Region Wise", value: "region" },
  ];

  const categories = variant === "2" ? variant2Categories : variant1Categories;



  useEffect(() => {
    if (query) {
      setCategorySelections(query);
    }
  }, []);

  const toggleTrust = (trust) => {
    const prevSelected = categorySelections[selectedCategory] || [];
    let updatedTrusts;
    // For object-based categories, store id
    const objectCategories = [
      "portfolios",
      "supervisors",
      "teamleads",
      "telecallers",
      "field_agents",
      
    ];
    if (objectCategories.includes(selectedCategory)) {
      const trustId = trust.id || trust;
      updatedTrusts = prevSelected.includes(trustId)
        ? prevSelected.filter((t) => t !== trustId)
        : [...prevSelected, trustId];
    } else {
      updatedTrusts = prevSelected.includes(trust)
        ? prevSelected.filter((t) => t !== trust)
        : [...prevSelected, trust];
    }
    const updatedSelections = {
      ...categorySelections,
      [selectedCategory]: updatedTrusts,
    };
    setCategorySelections(updatedSelections);
  };


  const handleSelectAll = () => {
    const filters =
      filter_list?.find((item) => item?.name === selectedCategory)?.filters || [];

    const values = selectedCategory === "portfolios"
      ? filters.map(f => f.id)
      : filters.map(f => f.name);

    const updatedSelections = {
      ...categorySelections,
      [selectedCategory]: values,
    };

    setCategorySelections(updatedSelections);
    // setSecondaryItems(values);
  };


  const clearAll = () => {
    const clearedSelections = Object.keys(categorySelections).reduce(
      (acc, key) => {
        acc[key] = [];
        return acc;
      },
      {}
    );
    setCategorySelections(clearedSelections);
    dispatch(setQuery({}));
    // setSecondaryItems([]);
  };


  const applyFilters = () => {
    setOpen(false);
    setReadyToApply(true);
    dispatch(setQuery(categorySelections));
    updateApis(categorySelections);
    if (typeof fetchData === "function") {
      dispatch(fetchData(categorySelections)).then(() =>
        setReadyToApply(false)
      );
    }
    if (typeof fetchData2 === "function") {
      dispatch(fetchData2(categorySelections));
    }
    if (typeof fetchData3 === "function") {
      dispatch(fetchData3(categorySelections));
    }
  };


  const toggleFavorite = (trust) => {
    // Implement favorite logic if needed
  };

  const handleSelectCategory = (cat) => {
    setSelectedCategory(cat?.value);
    // if (cat.title !== "Favourites" && cat.title !== "Recently Selected") {
    //   setPrimaryItems([cat?.title]);
    // }
  };



  const filteredCategories = useMemo(() => {
    if (!searchTerm) {
      // Default: show all categories with all their filters
      return categories.map((cat) => ({
        ...cat,
        filteredFilters:
          filter_list?.find((f) => f.name === cat.value)?.filters || [],
      }));
    }

    // New: Global search results
    let searchResults = [];
    categories.forEach((cat) => {
      const allFilters =
        filter_list?.find((f) => f.name === cat.value)?.filters || [];

      const matchedFilters = allFilters.filter((filter) =>
        filter.toLowerCase().includes(searchTerm.toLowerCase())
      );

      if (matchedFilters.length > 0) {
        searchResults.push(...matchedFilters.map((f) => ({ filter: f, category: cat.title })));
      }
    });

    // If we have global results, create a single "Search Results" category
    if (searchResults.length > 0) {
      return [
        {
          title: "Search Results",
          value: "search_results",
          filteredFilters: searchResults.map((res) => `${res.filter} (${res.category})`),
        },
      ];
    }

    return [];
  }, [categories, filter_list, searchTerm]);


  const dropdownContent = (
    <div className="custom-dropdown">
      <div className="filter-header">
        <div>
          <h2>Filter</h2>
          <img
            src={crossIcon}
            alt="Close"
            height={15}
            width={15}
            onClick={() => setOpen(false)}
          />
        </div>
        
      </div>
      <div className="status-line">
        <div>Category</div>
        <div>Metric</div>
        
      </div>
      <div className="filter-body" style={{
    gridTemplateColumns:'1fr 1fr',
 
      }}>
        <div className="filter-categories">
          {filteredCategories?.map((cat, index) => {
            const isDividerNeeded = cat.title === "Favourites";
            return (
              <React.Fragment key={index}>
                <Button
                  className={selectedCategory === cat?.value ? "active" : ""}
                  onClick={() => handleSelectCategory(cat)}
                  block
                  icon={
                    cat.title === "Recently Selected" ? (
                      <img src={recentIcon} alt="recent" />
                    ) : cat.title === "Favourites" ? (
                      <img src={favoIcon} alt="favourites" />
                    ) : null
                  }
                >
                  {cat?.title}
                </Button>
                {isDividerNeeded && <div className="divider-container" />}
              </React.Fragment>
            );
          })}
        </div>
        <div className="filter-metrics">
          <div className="select-all">
            <button onClick={handleSelectAll}>Select All</button>
          </div>
          <div className="trust-list">
            {filteredCategories
              .find((c) => c.value === selectedCategory)
              ?.filteredFilters?.map((trust) => (
                <div key={trust.id || trust} className="trust-item">
                  <Checkbox
                    checked={
                      ["portfolios", "supervisors", "teamleads", "telecallers", "field_agents"].includes(selectedCategory)
                        ? (categorySelections[selectedCategory] || []).includes(trust.id)
                        : (categorySelections[selectedCategory] || []).includes(trust)
                    }
                    onChange={() =>
                      ["portfolios", "supervisors", "teamleads", "telecallers", "field_agents"].includes(selectedCategory)
                        ? toggleTrust(trust)
                        : toggleTrust(trust)
                    }
                  >
                    {trust.name || trust}
                  </Checkbox>
                  <span
                    className="favorite-icon"
                    onClick={() => toggleFavorite(trust)}
                  >
                    <img src={starIcon} alt="star" />
                  </span>
                </div>
              ))}
          </div>

        </div>
      
      </div>
      <div className="filter-footer">
        <Button onClick={clearAll} type="text">
          Clear all
        </Button>
        <Button onClick={applyFilters} type="primary">
          Apply
        </Button>
      </div>
    </div>
  );

  const mobileMenuDropdownContent = (
    <div className="custom-dropdown mobile-dropdown">
      <div className="filter-header">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ fontSize: 16, fontWeight: 600 }}>Filter</h2>
          <img
            src={crossIcon}
            alt="Close"
            height={16}
            width={16}
            style={{ cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </div>
      </div>

      <Collapse defaultActiveKey={["1"]}>
        {filteredCategories?.map((cat, index) => {
          const currentFilter = cat.filteredFilters;
          const currentSelections = categorySelections[cat.value] || [];

          return (
            <Panel
              header={
                <Flex gap={2}>
                  <Badge count={currentSelections?.length} offset={[10, 1]}>
                    <h2 style={{ fontSize: 13, fontWeight: 500 }}>
                      {cat?.title}
                    </h2>
                  </Badge>
                </Flex>
              }
              key={index + 1}
              className="filter-panel"
            >
              <div className="filter-metrics">
                <div className="select-all">
                  <button
                    onClick={() => {
                      const updatedSelections = {
                        ...categorySelections,
                        [cat.value]: [...currentFilter],
                      };
                      setCategorySelections(updatedSelections);
                      // if (cat.value === selectedCategory) {
                      //   setSecondaryItems([...currentFilter]);
                      // }
                    }}
                  >
                    Select All
                  </button>
                </div>
                <div className="trust-list">
                  {currentFilter.map((trust) => (
                    <div key={trust} className="trust-item">
                      <Checkbox
                        checked={currentSelections.includes(trust)}
                        onChange={() => {
                          const updated = currentSelections.includes(trust)
                            ? currentSelections.filter((t) => t !== trust)
                            : [...currentSelections, trust];

                          const updatedSelections = {
                            ...categorySelections,
                            [cat.value]: updated,
                          };

                          setCategorySelections(updatedSelections);
                          // if (cat.value === selectedCategory) {
                          //   setSecondaryItems(updated);
                          // }
                        }}
                      >
                        {trust}
                      </Checkbox>
                      <span
                        className="favorite-icon"
                        onClick={() => toggleFavorite(trust)}
                      >
                        <img src={starIcon} alt="star" />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Panel>
          );
        })}
      </Collapse>

      <div className="filter-footer">
        <Button onClick={clearAll} type="text">
          Clear all
        </Button>
        <Button onClick={applyFilters} type="primary">
          Apply
        </Button>
      </div>
    </div>
  );

  const isDropdown = useMemo(() => {
    return screenWidth > 800 ? dropdownContent : mobileMenuDropdownContent;
  }, [screenWidth, filteredCategories, categorySelections, searchTerm]);


  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => isDropdown}
      placement="bottomLeft"
      trigger={["click"]}
    >
      {variant === "2" ? (
        <img
          src={FilterIcon2}
          alt="Filter Icon"
          style={{ cursor: "pointer" }}
        />
      ) : (
        <Button
          style={{ height: "35px", fontWeight: 500 }}
          className="allocationFilterBtn"
        >
          Filter <DownOutlined />
        </Button>
      )}
    </Dropdown>
  );
};

export default FilterDropdown;
